import { TimesheetFilters } from 'entities/timesheet';

const filterMap: Record<string, string | [string, string]> = {
  status: 'timesheetStatus',
  projectedCostHours: ['minProjectedCostHours', 'maxProjectedCostHours'],
  actualCostHours: ['minActualCostHours', 'maxActualCostHours'],
  projectedBillHours: ['minProjectedBillHours', 'maxProjectedBillHours'],
  actualBillHours: ['minActualBillHours', 'maxActualBillHours'],
  involvement: ['minInvolvement', 'maxInvolvement'],
  billedInvolvement: ['minBilledInvolvement', 'maxBilledInvolvement'],
  billable: 'billable',
};

export const mapFiltersToFilterDTO = (value: Record<string, string[] | null>): TimesheetFilters => {
  const filter: TimesheetFilters = {};
  if (!value) return filter;

  Object.entries(value).forEach(([key, currentValue]) => {
    const mapValue = filterMap[key];
    if (!mapValue || currentValue == null) return;

    const [minValue, maxValue] = currentValue;

    if (Array.isArray(mapValue)) {
      const [minKey, maxKey] = mapValue;
      if (minValue != null) {
        (filter as Record<string, unknown>)[minKey] = Number(minValue);
      }
      if (maxValue != null) {
        (filter as Record<string, unknown>)[maxKey] = Number(maxValue);
      }
    } else if (currentValue.length === 1) {
      if (mapValue === 'timesheetStatus') {
        (filter as Record<string, unknown>)[mapValue] = minValue === 'true' ? 'APPROVED' : 'NOT_APPROVED';
      } else {
        (filter as Record<string, unknown>)[mapValue] = minValue === 'true';
      }
    } else {
      (filter as Record<string, unknown>)[mapValue] = null;
    }
  });

  return filter;
};
